import { assign, BoundedBuffer, createContextManager, makePublicApi, monitor, display, deepClone, canUseEventBridge, timeStampNow } from '@datadog/browser-core';
import { validateAndBuildLogsConfiguration } from '../domain/configuration';
import { Logger } from '../domain/logger';
export function makeLogsPublicApi(startLogsImpl) {
  var isAlreadyInitialized = false;
  var globalContextManager = createContextManager();
  var customLoggers = {};
  var beforeInitLoggerLog = new BoundedBuffer();

  var _handleLogStrategy = function handleLogStrategy(logsMessage, logger, savedCommonContext, date) {
    if (savedCommonContext === void 0) {
      savedCommonContext = deepClone(getCommonContext());
    }

    if (date === void 0) {
      date = timeStampNow();
    }

    beforeInitLoggerLog.add(function () {
      return _handleLogStrategy(logsMessage, logger, savedCommonContext, date);
    });
  };

  var getInitConfigurationStrategy = function getInitConfigurationStrategy() {
    return undefined;
  };

  var mainLogger = new Logger(function () {
    var params = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      params[_i] = arguments[_i];
    }

    return _handleLogStrategy.apply(void 0, params);
  });

  function getCommonContext() {
    return {
      view: {
        referrer: document.referrer,
        url: window.location.href
      },
      context: globalContextManager.get()
    };
  }

  return makePublicApi({
    logger: mainLogger,
    init: monitor(function (initConfiguration) {
      if (canUseEventBridge()) {
        initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
      }

      if (!canInitLogs(initConfiguration)) {
        return;
      }

      var configuration = validateAndBuildLogsConfiguration(initConfiguration);

      if (!configuration) {
        return;
      }

      ;
      _handleLogStrategy = startLogsImpl(configuration, getCommonContext, mainLogger).handleLog;

      getInitConfigurationStrategy = function getInitConfigurationStrategy() {
        return deepClone(initConfiguration);
      };

      beforeInitLoggerLog.drain();
      isAlreadyInitialized = true;
    }),
    getLoggerGlobalContext: monitor(globalContextManager.get),
    setLoggerGlobalContext: monitor(globalContextManager.set),
    addLoggerGlobalContext: monitor(globalContextManager.add),
    removeLoggerGlobalContext: monitor(globalContextManager.remove),
    createLogger: monitor(function (name, conf) {
      if (conf === void 0) {
        conf = {};
      }

      customLoggers[name] = new Logger(function () {
        var params = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          params[_i] = arguments[_i];
        }

        return _handleLogStrategy.apply(void 0, params);
      }, name, conf.handler, conf.level, conf.context);
      return customLoggers[name];
    }),
    getLogger: monitor(function (name) {
      return customLoggers[name];
    }),
    getInitConfiguration: monitor(function () {
      return getInitConfigurationStrategy();
    })
  });

  function overrideInitConfigurationForBridge(initConfiguration) {
    return assign({}, initConfiguration, {
      clientToken: 'empty'
    });
  }

  function canInitLogs(initConfiguration) {
    if (isAlreadyInitialized) {
      if (!initConfiguration.silentMultipleInit) {
        display.error('DD_LOGS is already initialized.');
      }

      return false;
    }

    return true;
  }
}